import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const StnInward = () => {
   useAuthRedirect();
  const { stnNo, stnBranch } = useParams();
  const branch = localStorage.getItem("branch");
  const user = localStorage.getItem("username");

  const [header, setHeader] = useState({});
  const [data, setData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]); 
  const [selectAll, setSelectAll] = useState(false); 
  const navigate = useNavigate();

  const canEntry = hasPermission("STN Inward", "entry");

  useEffect(() => {
    const fetchIndentDetails = async () => {
      try {
  Swal.fire({
                        title: "Fetching STN Details",
                        html: `
                          <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
                            <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
                          </div>
                          <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch STN Details...</p>
                        `,
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                          const style = document.createElement("style");
                          style.innerHTML = `
                            @keyframes progressBar {
                              0% { width: 0% }
                              50% { width: 100% }
                              100% { width: 0% }
                            }
                          `;
                          document.head.appendChild(style);
                        },
                      });
        
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/stnInward_detailsHeader?stnNo=${stnNo}&branch=${branch}`
        );
        if (response.data && response.data.headerDetails?.length > 0) {
          const items = response.data.headerDetails;
          const storeReqHeader = {
            headerNo: items[0].sfIssuesHeader_number || "N/A",
            type: items[0].sfIssuesHeader_type || "N/A",
            transferBranch: items[0].sfIssuesHeader_branchcode || "N/A",
            InwardDate: items[0].sfIssuesHeader_date || "N/A",
            indentNo: items[0].sfIssuesHeader_indentNumber || "N/A",
            remarks: items[0].sfIssuesHeader_remarks || "N/A",
            shift: items[0].sfissuesHeader_shiftNumber || "N/A",
          };
          setHeader(storeReqHeader);
        }
        Swal.close();
      } catch (error) {
          Swal.close();
                                console.error("Error fetching STN Details. Please try again:", error);
                                Swal.fire({
                                  icon: "error",
                                  title: "Oops!",
                                  text: "Error fetching STN Details. Please try again",
                                });
      }
    };
{canEntry && (
    fetchIndentDetails()
)}
  }, [stnNo, branch]);

  useEffect(() => {
    axios
      .get(`https://rfs2.infraconsoft.net.in/api/stnInward_listData?stnNo=${stnNo}&branch=${stnBranch}`)
      .then((response) => {
        setData(response.data.bottomDetails);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [stnNo, stnBranch]);

  // Handle checkbox selection
  const handleCheckboxChange = (itemCode) => {
    setSelectedItems((prevSelected) =>
      prevSelected.includes(itemCode)
        ? prevSelected.filter((code) => code !== itemCode)
        : [...prevSelected, itemCode]
    );
  };

  // Handle "Select All" checkbox
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([]); // Unselect all
    } else {
      setSelectedItems(data.map((item) => item.sfissuesDetail_itemCode)); // Select all
    }
    setSelectAll(!selectAll);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Filter only selected items
    const selectedData = data.filter((item) => selectedItems.includes(item.sfissuesDetail_itemCode));

    if (selectedData.length === 0) {
      Swal.fire("Warning", "Please select at least one item.", "warning");
      return;
    }

    const payload = {
      branch: branch,
      stnNo : header.headerNo,
      user: user,
      inwardNo: stnNo,
      type: header.type,
      indentNo: header.indentNo,
      remarks: header.remarks,
      shift: header.shift,
      items: selectedData.map((item) => ({
        itemCode: item.sfissuesDetail_itemCode,
        itemName: item.itemmaster_name,
        itemUom: item.itemmaster_uom,
        orderedQuantity: item.sfissuesDetail_issuedQuantity,
        price: item.sfIssuesDetail_price,
        value: (item.sfIssuesDetail_price * item.sfissuesDetail_issuedQuantity).toFixed(2),
      })),
    };

    try {
          Swal.fire({
                            title: "Submitting...",
                            text: "Please wait while we process your request.",
                            allowOutsideClick: false,
                            didOpen: () => {
                                Swal.showLoading();
                            },
                        });

      await axios.post("https://rfs2.infraconsoft.net.in/api/stnInward_insert", payload);
      Swal.fire("Success", "Data submitted successfully!", "success");
      setSelectedItems([]);
      setSelectAll(false);
      navigate('/inventory/stockTransferNotependingView');
    } catch (error) {
      console.error("Error submitting form:", error);
      Swal.fire("Error", "Submission failed. Please try again.", "error");
    }
  };

   if (!canEntry) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <div className="back-div">
                        <h2 className="add-txt">STOCK TRANSFER NOTE - Inward</h2>
                        <Link to={`/inventory/stockTransferNotependingView`}><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                      </div>
          <h2 className="add-txt"></h2>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Store Issue No :</label>
                <input type="text" name="indentNo" value={header.headerNo} readOnly />
              </div>
              <div className="form-group">
                <label>Inward Date :</label>
                <input type="date" value={new Date().toISOString().split("T")[0]} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Stock Transfer From :</label>
                <input type="text" name="type" value={stnBranch} readOnly />
              </div>
              <div className="form-group">
                <label>Type :</label>
                <input type="text" name="branch" value={header.type} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Indent Number :</label>
                <input type="text" value={header.indentNo} readOnly/>
              </div>

              <div className="form-group">
                <label>Shop Floor Issues Date :</label>
                <input type="text"value={header.InwardDate ? new Date(header.InwardDate).toISOString().split("T")[0] : ""} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Remarks :</label>
                <input type="text" value={header.remarks} readOnly/>
              </div>

              <div className="form-group">
                <label>Shift :</label>
                <input type="text" value={header.shift} readOnly/>
              </div>
            </div>

            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>Quantity</th>
                    <th>Price</th>
                    <th>Value</th>
                    <th>
                     <button
  type="button"
  onClick={handleSelectAll}
  style={{
    backgroundColor: selectAll ? "#e63946" : "#1d3557",
    color: "white",
    border: "none",
    borderRadius: "8px",
    padding: "8px 16px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "600",
    transition: "all 0.3s ease",
  }}
  onMouseOver={(e) => (e.target.style.backgroundColor = selectAll ? "#d62828" : "#457b9d")}
  onMouseOut={(e) => (e.target.style.backgroundColor = selectAll ? "#e63946" : "#1d3557")}
>
  {selectAll ? "Unselect All" : "Select All"}
</button>


                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                    <>
                      {data.map((item, index) => {
                        const value = item.sfIssuesDetail_price * item.sfissuesDetail_issuedQuantity;
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.sfissuesDetail_itemCode}</td>
                            <td>{item.itemmaster_name}</td>
                            <td>{item.itemmaster_uom}</td>
                            <td>{item.sfissuesDetail_issuedQuantity}</td>
                            <td>{item.sfIssuesDetail_price}</td>
                            <td>{value.toFixed(2)}</td>
                            <td>
                              <input
                                type="checkbox"
                                checked={selectedItems.includes(item.sfissuesDetail_itemCode)}
                                onChange={() => handleCheckboxChange(item.sfissuesDetail_itemCode)}
                              />
                            </td>
                          </tr>
                        );
                      })}
<tr>
  <td colSpan={6}><strong>Total Value</strong></td>
  <td>
    <strong>
      {data
        .filter((item) => selectedItems.includes(item.sfissuesDetail_itemCode))
        .reduce((acc, item) => acc + item.sfIssuesDetail_price * item.sfissuesDetail_issuedQuantity, 0)
        .toFixed(2)}
    </strong>
  </td>
  <td></td>
</tr>

                    </>
                  ) : (
                    <tr>
                      <td colSpan="9">No items</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Inward
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default StnInward;
